import React from 'react';
import { Link } from 'react-router-dom';


const Saturn = () => {
	return (
		<>
		<p><Link to="/">Home</Link></p>
		<h1>Saturn</h1>

		<img alt="Planet Saturn Mythology" src="https://cdn.britannica.com/67/21167-004-6B1CF05E/Saturn-storm-Earth-region-observations-image-Hubble-December-1-1994.jpg" style={{"width":"325px","margin-top":"10px"}}/>

		<p className="godLink"><a href="https://en.wikipedia.org/wiki/Cronus" >Cronus - Greek</a></p>
		<p className="godDescription">Usually depicted with a harpe, scythe or a sickle. Patron of the harvest</p>
		
		<p className="godLink"><a href="https://en.wikipedia.org/wiki/Ninurta" >Ninurta - Sumerian</a></p>
		<p className="godDescription">Associated with farming, healing, hunting, law, scribes, and war who was first worshipped in early Sumer. In the earliest records, he is a god of agriculture and healing, who releases humans from sickness and the power of demons. In later times, as Mesopotamia grew more militarized, he became a warrior deity, though he retained many of his earlier agricultural attributes.</p>		

		<p className="godLink"><a href="https://en.wikipedia.org/wiki/Saturn_(mythology)" >Saturn - Roman</a></p>
		<p className="godDescription">Described as a god of generation, dissolution, plenty, wealth, agriculture, periodic renewal and liberation</p>

		<p className="godLink"><a href="https://en.wikipedia.org/wiki/Shani" >Shani - Hindu</a></p>
		<p className="godDescription">Iconography consists of a black figure carrying a sword or danda (sceptre), and sitting on a Crow. He is the god of Karma, justice and retribution in the Hindu religion and delivers results to all, depending upon their thoughts, speech and deeds (karma), which could be a positive or negative impact on their lives. He also signifies spiritual asceticism, penance, discipline and conscientious work.</p>

		<p className="godLink"><a href="https://en.wikipedia.org/wiki/Yellow_Emperor" >Huangdi - Chinese</a></p>
		<p className="godDescription">Huangdi's cult became prominent in the late Warring States and early Han dynasty, when he was portrayed as the originator of the centralized state, as a cosmic ruler, and as a patron of esoteric arts. Having waned in influence during most of the imperial period, in the early twentieth century Huangdi became a rallying figure for Han Chinese attempts to overthrow the rule of the Qing dynasty, which they considered foreign because its emperors were Manchu people. To this day the Yellow Emperor remains a powerful symbol within Chinese nationalism. Traditionally credited with numerous inventions and innovations – ranging from the Chinese calendar to an early form of football – the Yellow Emperor is now regarded as the initiator of Chinese culture.</p>
		</>
		)
}

export default Saturn;



